import { LeaseSignatureInfo } from 'api/models';
import clsx from 'clsx';
import { ALIGN_ITEMS } from '../MaintenanceStatus/UserActionMaintenance/UserProfilePopout/UserProfilePopout';
import ResidentTileWithStatus, {
  ResidentProfileProps,
} from '../ResidentTileWithStatus/ResidentTileWithStatus';

type Props = {
  // The spread below is what reaches `ResidentTileWithStatus`, so the item type
  // has to be its props rather than an anonymous bag — `Record<string, unknown>`
  // contributed no `profileProps` and made every tile a missing-prop error.
  residents: { profileProps: ResidentProfileProps }[];
  orientation?: 'horizontal' | 'vertical';
  signatureInformation?: LeaseSignatureInfo;
};

const ResidentTileListWithStatus = ({
  residents,
  orientation = 'horizontal',
  signatureInformation,
}: Props) => {
  return (
    <div
      className={clsx('grid gap-md', {
        'grid-cols-1 justify-start': orientation === 'vertical',
        'grod-cols-1 md:grid-cols-2': orientation === 'horizontal',
      })}
    >
      {residents.map((resident, index) => (
        <div key={index} className="flex-auto basis-full md:basis-1/2">
          <ResidentTileWithStatus
            alignProfileItems={ALIGN_ITEMS.ALIGN_LEFT}
            {...resident}
            signatureInformation={signatureInformation}
          />
        </div>
      ))}
    </div>
  );
};

export default ResidentTileListWithStatus;
